module.exports = __webpack_public_path__ + "img/bg-tft.b0ec2a38.jpg";